module.exports = __webpack_public_path__ + "static/media/rack-bg.204a6fd2.jpg";